import React from 'react';
import { Link } from 'react-router-dom';
import { HelpHero } from '../components/HelpHero';
import { Breadcrumb } from '../components/Breadcrumb';
import { HelpCircle } from 'lucide-react';
import { articles, categories } from '../data/articles';
export function FAQPage() {
  const categoryArticles = articles.filter(a => a.categorySlug === 'preguntas-frecuentes');
  return <div className="min-h-screen bg-[#f8fafc]" data-id="element-315">
      <HelpHero title="Preguntas Frecuentes" subtitle="Todo lo que necesitas saber sobre nuestros servicios y procesos." showSearch={true} data-id="element-316" />

      <main className="max-w-7xl mx-auto px-4 md:px-8 py-10" data-id="element-317">
        <div className="flex flex-col lg:flex-row gap-10" data-id="element-318">
          {/* Left Sidebar */}
          <aside className="w-full lg:w-1/4 flex-shrink-0" data-id="element-319">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 sticky top-6" data-id="element-320">
              <h3 className="font-bold text-[#022a3b] mb-4 text-lg" data-id="element-321">
                Centro de Ayuda
              </h3>
              <nav className="space-y-1" data-id="element-322">
                {categories.map(category => <Link key={category.slug} to={`/${category.slug}`} className={`block py-2.5 px-3 rounded-md transition-colors ${category.slug === 'preguntas-frecuentes' ? 'bg-[#f0f9ff] text-[#0af] font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-[#022a3b]'}`} data-id="element-323">
                    {category.name}
                  </Link>)}
              </nav>
            </div>
          </aside>

          {/* Right Content */}
          <div className="w-full lg:w-3/4 bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-10" data-id="element-324">
            <Breadcrumb items={[{
            label: 'Preguntas Frecuentes'
          }]} data-id="element-325" />

            <div className="flex items-center gap-3 mb-8" data-id="element-326">
              <div className="p-2 bg-[#e0f2fe] rounded-lg text-[#0af]" data-id="element-327">
                <HelpCircle className="h-6 w-6" data-id="element-328" />
              </div>
              <h1 className="text-3xl font-bold text-[#022a3b]" data-id="element-329">
                Preguntas Frecuentes
              </h1>
            </div>

            <p className="text-gray-600 mb-8" data-id="element-330">
              Encuentra aquí las preguntas más buscadas ¡Tenemos la respuesta
              para ti!
            </p>

            <div className="space-y-0 divide-y divide-gray-100" data-id="element-331">
              {categoryArticles.map(article => <Link key={article.slug} to={`/${article.slug}`} className="block py-4 text-[#022a3b] hover:text-[#0af] transition-colors" data-id="element-332">
                  {article.title}
                </Link>)}
            </div>
          </div>
        </div>
      </main>
    </div>;
}